import type { ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface SectionCardProps {
  title: string;
  description?: string;
  action?: { label: string; onClick: () => void };
  children: ReactNode;
  className?: string;
  contentClassName?: string;
}

export function SectionCard({
  title,
  description,
  action,
  children,
  className,
  contentClassName,
}: SectionCardProps) {
  return (
    <section
      className={cn(
        'flex flex-col gap-4 rounded-2xl border border-content-highlight/35 bg-content-dark/45 p-5 text-white',
        className,
      )}
    >
      <header className="flex flex-wrap items-start justify-between gap-3">
        <div className="space-y-1">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-white/55">{title}</p>
          {description ? <p className="text-sm text-white/50">{description}</p> : null}
        </div>
        {action ? (
          <Button type="button" variant="ghost-light" size="sm" onClick={action.onClick}>
            {action.label}
          </Button>
        ) : null}
      </header>
      <div className={cn('min-w-0', contentClassName)}>{children}</div>
    </section>
  );
}
